export default "/images/vendor/flag-icon-css/flags/4x3/tv.svg?99618ffc3d126b12802f080330a16921";